import ltReviewOrderChildSummary from 'html/checkout/lt-review-order-child-summary.html';
import digitalDownloadIconHtml from 'html/shopping-cart/digital-download-icon.html';
import App from 'app/app.js';
import 'app/directive/LtOrderSummaryStepTwoCtrl.js';

function LtOrderSummaryStepTwoDirective($templateCache) {
  $templateCache.put('html/shopping-cart/digital-download-icon.html', digitalDownloadIconHtml);
  return {
    restrict: 'E',
    scope: {
      subjects: '='
    },
    template: ltReviewOrderChildSummary,
    controller: 'LtOrderSummaryStepTwoCtrl',
    controllerAs: 'orderSummaryStepTwo'
  };
}

App.directive('ltOrderSummaryStepTwo', ['$templateCache', LtOrderSummaryStepTwoDirective]);
